"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asTypedRolEchainUnion = exports.isRolEchainUnionUnsafe = exports.isRolEchainUnion = void 0;
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const RolEchain_1 = require("./RolEchain");
const isRolEchainUnion = (whatever, v) => (0, RolEchain_1.isRolEchainWithAdapterLink)(whatever, v) ||
    (0, RolEchain_1.isRolEchainWithModifiedLink)(whatever, v) ||
    (0, RolEchain_1.isRolEchainWithAutoglideLink)(whatever, v) ||
    (0, RolEchain_1.isRolEchainWithoutAdditionalLink)(whatever, v);
exports.isRolEchainUnion = isRolEchainUnion;
const isRolEchainUnionUnsafe = (whatever, v) => (0, RolEchain_1.isRolEchainWithAdapterLinkUnsafe)(whatever, v) ||
    (0, RolEchain_1.isRolEchainWithModifiedLinkUnsafe)(whatever, v) ||
    (0, RolEchain_1.isRolEchainWithAutoglideLinkUnsafe)(whatever, v) ||
    (0, RolEchain_1.isRolEchainWithoutAdditionalLinkUnsafe)(whatever, v);
exports.isRolEchainUnionUnsafe = isRolEchainUnionUnsafe;
const asTypedRolEchainUnion = (whatever) => {
    if ((0, RolEchain_1.isRolEchainWithAdapterLinkUnsafe)(whatever)) {
        return { type: 'RolEchainWithAdapterLink', model: whatever };
    }
    else if ((0, RolEchain_1.isRolEchainWithModifiedLinkUnsafe)(whatever)) {
        return { type: 'RolEchainWithModifiedLink', model: whatever };
    }
    else if ((0, RolEchain_1.isRolEchainWithAutoglideLinkUnsafe)(whatever)) {
        return { type: 'RolEchainWithAutoglideLink', model: whatever };
    }
    else if ((0, RolEchain_1.isRolEchainWithoutAdditionalLinkUnsafe)(whatever)) {
        return { type: 'RolEchainWithoutAdditionalLink', model: whatever };
    }
    (0, echain_shared_ts_utils_1.assertUnreachable)(whatever);
};
exports.asTypedRolEchainUnion = asTypedRolEchainUnion;
//# sourceMappingURL=RolEchainUnion.js.map